import React from 'react';

function BWPin() {
  return (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 19.7621L2.9315 14.1936C-0.143851 11.1182 -0.143831 6.13201 2.93155 3.05664C6.00692 -0.0187187 10.9931 -0.0187187 14.0685 3.05664C17.1438 6.13201 17.1439 11.1182 14.0685 14.1936L8.5 19.7621ZM12.8313 12.9563C15.223 10.5643 15.2229 6.68626 12.831 4.29439C10.439 1.90253 6.56099 1.90253 4.16904 4.29439C1.7771 6.68626 1.77697 10.5643 4.16875 12.9563L8.5 17.2876L12.8313 12.9563ZM6.75 8.62505C6.75 9.59155 7.5335 10.3751 8.5 10.3751C9.4665 10.3751 10.25 9.59155 10.25 8.62505C10.25 7.65856 9.4665 6.87505 8.5 6.87505C7.5335 6.87505 6.75 7.65856 6.75 8.62505Z"
        fill="black"
      />
    </svg>
  );
}

export default BWPin;
